
















import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { PublishedApp } from '../models';

@Component({})
export default class AppOverview extends Vue {
	@Getter public currentApp!: PublishedApp;
}
